export default __webpack_public_path__ + "static/media/Torpedo-2Closed.a1b4fff4.jpg";